import {passwordStrenthFuc,validatePassword} from '@/utils/common.js'

const registerMinxin = {
    data() {
        let _this = this;
        return {
            registerRules: {
                username:[
                    { required: true, message: this.$t('不能为空'), trigger: 'blur' },
                    { validator: _this.specialChart, trigger: 'blur' }
                ],
                telPhone:	{ required: true, message: this.$t('不能为空'), trigger: 'blur' },
                code:	{ required: true, message: this.$t('不能为空'), trigger: 'blur' },
                password: [
                    { required: true, trigger: 'blur', message: this.$t('不能为空')},
                    { trigger: 'change', validator: validatePassword },
                ],
                password2: [
                    { required: true, trigger: 'blur', message: this.$t('不能为空')},
                    { trigger: 'blur', validator: _this.validatePassword2 }
                ]
            },
            time:0,
            registerForm: {
                username:'',
                telPhone:'',
                code:'',
                areaCode:'',
                password: '',
                password2: ''
            },
            agree:false,
            showModal:false,
        }
    },
    components: {
        userAgreement: () => import('../components/userAgreement.vue')
    },
    methods: {
        validatePassword2(rule, value, callback){
            if(this.registerForm.password !=value){
                callback(new Error(this.$t('密码不一致')))
            }else{
                callback()
            }
        },
        getMessageCode(){
            let telPhone = this.registerForm.telPhone;
            if(!telPhone){
                this.$message({message:this.$t('请输入手机号码'),type:'warning'})
                return
            }
            this.$httpSys.post("smsAliyun/pass/aliyun/senderCodeRegister",{phone:telPhone,areaCode:this.registerForm.areaCode}).then(data=>{
                this.time = 60;
                let inter = setInterval(()=>{
                    this.time -- ;
                    if(this.time==0){
                        clearInterval(inter)
                    }
                },1000)
                this.$message({message:this.$t('发送成功'),type:'success'})
            })
        },
        checkAgreement() {
            this.agree = true
        },
        handleRegister() {
            this.$refs.registerForm.validate(valid => {
                if(valid) {
                    if(!this.agree) {
                        this.$message({message:this.$t('请勾选用户协议'),type:'warning'})
                        return false
                    }
                    this.$httpSys.post("auth/user/anon/register",this.registerForm).then(data=>{
                        this.changeType('loginForm')
                        this.$message({message:this.$t('操作成功'),type:'success'})
                    })
                }
            })
        }
    }
}

export default registerMinxin